import React, { useEffect } from "react";
import JobLinksSection from "../components/JobLinksSection";
import HeadTable from "../components/HeadTable";
import HomepageSingleColumnSection from "../components/HomepageSingleColumnSection";
import ThreeTableSection from "../components/ThreeTableSection";
import { useGlobalData } from "../context/GlobalDataContext";

function Home() {
  const { hydratePublicData, cancelThreeTableBackgroundRefresh } = useGlobalData();

  useEffect(() => {
    // grouped public fetch (guard + dedupe context me handle hoga)
    hydratePublicData();

    return () => {
      cancelThreeTableBackgroundRefresh();
    };
  }, [hydratePublicData, cancelThreeTableBackgroundRefresh]);

  return (
    <div>
      <JobLinksSection />
      <HeadTable />
      <ThreeTableSection />
      <HomepageSingleColumnSection />
      {/* other homepage sections */}
    </div>
  );
}

export default Home;